<template>
  <div>
    <section class="pt-[55px] pb-[70px] pc:py-[140px] pc-con-wrapper1">
      <p class="text-lg font-bold text-center pc:text-5xl text-neutral-950 mb-11">회원가입</p>
      <div class="px-5 border border-solid py-7 pc:py-11 border-neutral-200 rounded-2xl">
        <div class="flex flex-col items-center gap-8 pc:gap-12">
          <ul class="grid grid-cols-2 gap-5 pc:gap-10 w-full max-w-lg">
            <li
              class="py-8 pc:py-12 text-sm font-bold text-center text-white bg-orange-500 rounded cursor-pointer pc:text-xl leading-relaxed"
              @click="goSignUp('adult')"
            >
              일반 회원가입<br />(만 14세 이상)
            </li>
            <li
              class="py-8 pc:py-12 text-sm font-bold text-center text-white bg-orange-500 rounded cursor-pointer pc:text-xl leading-relaxed"
              @click="goSignUp('minor')"
            >
              미성년 회원가입<br />(만 14세 미만)
            </li>
          </ul>
          <p class="text-xs pc:text-base text-neutral-500">※ 수강신청 하고자 하는 [학습자] 기준으로 선택 바랍니다.</p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();

    function goSignUp(type) {
      router.push({ name: "signUp1", query: { type } });
    }

    return { goSignUp };
  },
};
</script>
<style scoped></style>
